import { FlexBox } from "components/Common/FlexBox"
import styled from "styled-components"

const Label = styled.div`
  padding: 4px 8px;
  border-radius: 4px;
  background: var(--white-white-5, rgba(255, 255, 255, 0.05));

  @supports ((-webkit-backdrop-filter: blur(60px)) or (backdrop-filter: blur(60px))) {
    -webkit-backdrop-filter: blur(60px);
    backdrop-filter: blur(60px);
  }

  font-size: 10px;
  font-weight: 700;
  line-height: 160%;
  color: var(--white-white-75, rgba(255, 255, 255, 0.75));
  text-transform: uppercase;
`

const Weight = styled.span`
  font-size: 28px;
  font-weight: 800;
  line-height: 28px;
`

const Unit = styled.span`
  font-size: 20px;
  font-weight: 700;
  line-height: 24px;
`

type WeightInfoType = "start" | "gain" | "lose"

const TargetDate = styled.div`
  color: var(--white-white-75, rgba(255, 255, 255, 0.75));
  font-size: 12px;
  font-weight: 700;
  line-height: 160%;
`

interface IWeightInfoProps {
  label: string
  type: WeightInfoType
  weight: string
  date: string
}

const getWeightColor = (type: WeightInfoType) => {
  switch (type) {
    case "start":
      return "#fff"

    case "gain":
      return "#FFC800"

    case "lose":
      return "#4BD9DE"

    default:
      return "#fff"
  }
}

const WeightInfo = (props: IWeightInfoProps) => {
  const { label, type, weight, date } = props
  const [weightNumber, unit] = weight.split(" ")
  const align = type === "start" ? "flex-start" : "flex-end"

  return (
    <FlexBox
      $alignItems={align}
      $gap={8}
      $direction="column"
    >
      <Label>{label}</Label>

      <FlexBox $direction="column" $alignItems={align}>
        <FlexBox
          $gap={2}
          style={{ color: getWeightColor(type) }}
          $alignItems="flex-end"
        >
          <Weight>{weightNumber}</Weight>
          <Unit>{unit}</Unit>
        </FlexBox>

        <TargetDate>{date}</TargetDate>
      </FlexBox>
    </FlexBox>
  )
}

export default WeightInfo
